import { LangType } from '../../helpers/lang';
import { AddressType, RequisitesType, SocialType } from '../../types/props';
import { managerApiUrl } from './manager-api';
import { baseFetch } from './utils.ts/base-fetch';

export type CompanyType = {
  company_name: string;
  currency: string;
  default_lang: string;
  is_show_currency_decimal: boolean;
  services: string[];
  supported_langs: string[];
  timezone: string;
};

export const fetchCompany = async (): Promise<CompanyType> => {
  const response = await baseFetch(`${managerApiUrl}/me/company`);
  return response;
};

export type ShiftNotificationsType = {
  possible_delay: number;
  serious_delay: number;
};

export type CompanyProfileType = {
  actual_address: AddressType;
  credentials: Partial<RequisitesType>;
  legal_address: AddressType;
  name: string;
  description?: LangType;
  socials: SocialType[];
  is_wifi_check_enabled: boolean;
  app?: {
    logo?: {
      normal?: string;
      thumbnail?: string;
    };
    font?: string;
    background?: string;
    colors?: {
      primary?: {
        elements?: string;
        text?: string;
      };
      secondary?: {
        elements?: string;
        text?: string;
      };
      icon?: {
        bg?: string;
        stroke?: string;
      };
    };
  };
  notifications?: {
    shifts?: Partial<ShiftNotificationsType>
  }
};

export const fetchCompanyProfile = async (): Promise<CompanyProfileType> => {
  const response = await baseFetch(`${managerApiUrl}/me/profile/company`);
  return response;
};

export const putCompanyProfile = async (
  data: Partial<CompanyProfileType>,
): Promise<CompanyProfileType> => {
  const resp = await baseFetch(`${managerApiUrl}/me/profile/company`, {
    method: 'PUT',
    body: JSON.stringify(data),
  });
  return resp;
};
